import { useOktaAuth } from '@okta/okta-react';
import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Box, Heading } from '@chakra-ui/react';
import PulseLoader from "react-spinners/PulseLoader";

const Home = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const { authState, oktaAuth } = useOktaAuth();
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const sessionToken = queryParams.get('sessionToken');
  const verifyUrl = import.meta.env.VITE_VERIFY_URL;

  const navigate = useNavigate();
  
  useEffect(() => {
    if (!authState || !authState.isAuthenticated) {
      // When user isn't authenticated, forget any user info
      setUserInfo(null);
    } else {
      oktaAuth.getUser().then((info) => {
        setUserInfo(info);
        setLoading(true);
        // Verify we have a MFA session in flight
        let fetchUrl = verifyUrl;
        if (sessionToken) {
          fetchUrl = verifyUrl + '?sessionid=' + sessionToken;
        }
        fetch(fetchUrl, {
          headers: {
            Authorization: 'Bearer ' + authState.accessToken.accessToken
          }
        })
          .then((res) => {
            return res.json();
          })
          .then((data) => {
            // Error in the validation response
            if (data.statusCode && data.statusCode !== 200) {
              setLoading(false);
              console.log(data);
              navigate('/Error', { state: { errorMessage: data.message } });
            } else {
              // Success in the validation response
              console.log(data);
              setLoading(false);
              // Only manager validation flows returns a target_user
              if (data.target_user) {
                console.log('Manager validation flow');
                if (data.challenge_flow === 'password_reset') {
                  navigate('/Manager-PasswordReset', { state: { validationData: data } });
                }  else if (data.challenge_flow === 'add_ext_email') {
                  navigate('/Manager-AddExternalEmail', { state: { validationData: data } });
                } else if (data.challenge_flow === 'identity_validation') {
                  navigate(`/Manager-IdentityValidation?token=${data.session_id}`);
                } else {
                  navigate('/Error', { state: { errorMessage: "Unknown Identity Validation Flow: " + data.challenge_flow } });
                }
              } else {
                console.log('Self-Service validation flow');
                if (data.challenge_flow === 'password_reset') {
                  navigate('/PasswordReset', { state: { validationData: data } });
                } else if (data.challenge_flow === 'identity_validation') {
                  navigate('/IdentityValidation', { state: { validationData: data } });
                }
              }
            }
          }).catch(error => {
            // Error requesting the verification
            console.log(error);
            setLoading(false);
            navigate('/Error', { state: { errorMessage: error } });
          });
        });
      }
  }, [authState, oktaAuth]); // Update if authState changes

  if (!authState) {
    if (sessionToken) {
      oktaAuth.signInWithRedirect({ originalUri: '/?sessionToken='+sessionToken });
    } else {
      oktaAuth.signInWithRedirect({ originalUri: '/' });
    }
    return (
      <div>Loading...</div>
    );
  }

  return (
      <div id="home">
        { loading &&
          <div className="sweet-loading">
            <div className="centered">
              <PulseLoader
                  loading={loading}
                  color="#dadada"
                  size={30}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
            </div>
          </div>
        }
    </div>
  );
};
export default Home;
